import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../components/navbar.css";

function Navbar() {
  return (
    <nav
      style={{ borderRadius: "40px" }}
      id="top_nav"
      className="navbar navbar-expand-lg navbar-light sticky-top"
    >
      <div className="container-fluid">
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarContent"
          aria-controls="navbarContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Navbar Links */}
        <div className="collapse navbar-collapse" id="navbarContent">
          <ul className="navbar-nav w-100 d-flex justify-content-evenly">
        
            <li className="nav-item">
              <Link className="nav-link underline-hover" to="/intro">
                Introduction
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link underline-hover" to="/article">
                Article
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link underline-hover" to="/news">
                News
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link underline-hover" to="/posters">
                Posters
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link underline-hover" to="/report">
                Reports
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link underline-hover" to="/bibliography">
                Bibliography
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link underline-hover" to="/experts">
                Experts
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link underline-hover" to="/announcements">
                Announcements
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link underline-hover" to="/e-links">
                E-links
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link underline-hover" to="/books">
                Books
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link underline-hover" to="/forum">
                Forum
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link underline-hover" to="/webinar">
                Webinar
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link underline-hover" to="/editors">
                Editors
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
